<template>
    <q-card
        bordered
        class="ModelCard cursor-pointer"
        tabindex="0"
        @click="handleGoToVisualization"
        @keypress.enter="handleGoToVisualization"
    >
        <q-card-section class="ModelCardHeader bg-primary text-white">
            <div class="flex row-stretch-center no-wrap">
                <q-icon
                    name="schema"
                    size="22px"
                    color="white"
                    class="q-mr-sm"
                />
                <div class="ModelCardTitle ellipsis">
                    {{ row.modelName }}
                </div>
                <q-space />
                <q-btn
                    key="info"
                    icon="info"
                    color="white"
                    dense
                    flat
                    @click.stop="handleInfo"
                >
                    <q-tooltip>{{ $t('general.info') }}</q-tooltip>
                </q-btn>
                <q-btn
                    icon="more_vert"
                    color="white"
                    dense
                    flat
                    @click.stop="openMenu(row, $event)"
                />
            </div>
        </q-card-section>

        <q-card-section class="ModelCardBody bg-white">
            <div class="flex items-center no-wrap">
                <QBadge
                    :label="sourceLabel"
                    :color="sourceColor"
                    outline
                    class="q-mr-sm"
                />
            </div>
        </q-card-section>

        <q-menu
            v-if="menuActivator"
            v-model="menuOpen"
            :target="menuActivator"
            @hide="cleanSelected"
        >
            <q-list dense class="text-caption">
                <q-item
                    v-for="option in (row.options || {}).dropdown"
                    :key="option.key"
                    clickable
                    @click="handleClickOption(option)"
                >
                    <q-item-section avatar>
                        <q-icon :name="option.icon" :color="option.iconColor" />
                    </q-item-section>
                    <q-item-section>
                        {{ option.label }}
                    </q-item-section>
                </q-item>
            </q-list>
        </q-menu>
    </q-card>
</template>

<script>
import VueTypes from 'vue-types'
import { filtersMixin } from '@/mixins'

export default {
    name: 'ModelCard',
    components: {
    },
    mixins: [filtersMixin],
    props: {
        row: VueTypes.any,
    },
    emits: ['handleEmit', 'onVisualization'],
    data() {
        return {
            selected: undefined,
            menuOpen: false,
            menuActivator: null,
        }
    },
    computed: {
        sourceLabel() {
            if (this.row.datasetId === null) {
                return this.$t('projects.models.source.uploaded')
            }
            return this.$t('projects.models.source.dataset')
        },
        sourceColor() {
            if (this.row.datasetId === null) {
                return 'primary'
            }
            return 'secondary'
        },
    },
    methods: {
        handleInfo() {
            this.handleEmit('onInfo')
        },
        openMenu(row, event) {
            this.selected = row
            this.menuActivator = event?.currentTarget || event?.target || null
            if (!this.menuActivator) return
            this.menuOpen = true
        },
        cleanSelected() {
            this.menuOpen = false
            this.selected = undefined
            this.menuActivator = null
        },
        handleClickOption(option) {
            if (option.event) {
                this.handleEmit(option.event)
            }
            this.cleanSelected()
        },
        handleEmit(event) {
            this.$emit('handleEmit', event)
        },
        handleGoToVisualization() {
            this.handleEmit('onVisualization')
        },
    },
}
</script>
<style scoped lang="scss">
.ModelCard {
    overflow: hidden;
    height: 100%;
}

.ModelCardTitle {
    max-width: 100%;
}
</style>
